export default function slugify(input: string) {
    return input
        .toLowerCase()
        .normalize('NFD')
        .replaceAll(/[\u0300-\u036f]/g, '')
        .replaceAll(/\s+/g, '-')
        .replaceAll('ø', 'o')
        .replaceAll('æ', 'ae')
        .replaceAll('å', 'a')
        .replaceAll(/[^a-z0-9-]+/g, '')
        .substring(0, 200);
}
